<template>
  <b-field
    :message="message ? message : ''"
    :type="theType"
    :label-position="labelPosition"
    :custom-class="customClass"
  >
    <template #label>
      {{ label }}
      <b-tooltip
        v-if="tooltip"
        type="is-dark"
        :label="tooltip"
        multilined
        append-to-body
        :position="tooltipPosition"
      >
        <b-icon size="is-small" icon="info-circle"></b-icon>
      </b-tooltip>
    </template>
    <slot />
  </b-field>
</template>

<script>
export default {
  name: 'FieldWithHelp',
  props: {
    label: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
    labelPosition: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: Object,
      required: false
    },
    message: {
      type: String,
      required: false
    },
    tooltipPosition: {
      type: String,
      required: false,
      default: 'is-top'
    },
    customClass: {
      type: String,
      required: false
    }
  },
  computed: {
    theType () {
      if (this.type) {
        return this.type
      }
      if (this.message) {
        return 'is-danger'
      }
      return ''
    }
  }
}
</script>

<style></style>
